export default function landingPageSections(Alpine) {
  Alpine.data("landingPageObserver", (sections = [], options = {}) => ({
    active: "",
    sections,
    observer: null,
    ratios: new Map(),
    rootMargin: options.rootMargin ?? "-20% 0px -60% 0px",
    threshold: options.threshold ?? [0, 0.25, 0.5, 0.75, 1],
    prefersReducedMotion: false,
    motionQuery: null,
    motionHandler: null,

    init() {
      this.motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
      this.prefersReducedMotion = this.motionQuery.matches;
      this.motionHandler = (e) => {
        this.prefersReducedMotion = e.matches;
      };
      this.motionQuery.addEventListener("change", this.motionHandler);

      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            this.ratios.set(entry.target.id, entry.isIntersecting ? entry.intersectionRatio : 0);
          }

          let bestId = "";
          let bestRatio = 0;
          for (const [id, ratio] of this.ratios) {
            if (ratio > bestRatio) {
              bestRatio = ratio;
              bestId = id;
            }
          }

          if (bestId === this.active) return;
          this.setActive(bestId, false);
        },
        {
          rootMargin: this.rootMargin,
          threshold: this.threshold,
        },
      );

      this.sections.forEach(({ id }) => {
        const section = this.getSection(id);
        if (section) this.observer.observe(section);
      });

      this.active = window.location.hash.substring(1);
    },

    getSection(id) {
      return this.$root.querySelector(`#${CSS.escape(id)}`);
    },

    scrollBehavior() {
      return this.prefersReducedMotion ? "auto" : "smooth";
    },

    setActive(id, updateHash = true) {
      this.active = id;
      if (!id) return;

      if (updateHash) {
        history.replaceState(null, "", `#${id}`);
      }
      this.$nextTick(() => {
        this.$refs.nav?.querySelector(`[data-section="${id}"]`)?.scrollIntoView({
          behavior: this.scrollBehavior(),
          inline: "center",
          block: "nearest",
        });
      });
    },

    go(id) {
      this.getSection(id)?.scrollIntoView({
        behavior: this.scrollBehavior(),
        block: "start",
      });
      this.setActive(id);
    },

    isActive(id) {
      return this.active !== "" && this.active === id;
    },

    destroy() {
      this.motionQuery?.removeEventListener("change", this.motionHandler);
      this.observer?.disconnect();
      this.ratios.clear();
    },
  }));
}
